import React from 'react';
import { StaticDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Box, OutlinedInput } from '@mui/material';
import { viVN } from '@mui/x-date-pickers/locales';
import format from 'date-fns/format';
import { vi } from 'date-fns/locale'; // Import Vietnamese locale

const MyStaticDatePicker = ({ onAgree, onlyMonth = false }) => {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      localeText={viVN.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <Box sx={{ position: 'relative', border: '1px solid #ccc', borderRadius: '4px', p: 2 }}>
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          openTo={onlyMonth ? 'month' : 'day'} // Open to 'month' or 'day' based on the flag
          views={onlyMonth ? ['year', 'month'] : ['year', 'month', 'day']} // Toggle views
          onAccept={(date) => {
            // Format the date based on the `onlyMonth` flag
            const formattedDate = date
              ? onlyMonth
                ? format(new Date(date), 'MM/yyyy', { locale: vi }) // Format as MM/yyyy
                : format(new Date(date), 'dd/MM/yyyy', { locale: vi }) // Format as dd/MM/yyyy
              : '';
            if (onAgree) onAgree(formattedDate); // Pass formatted date to parent
          }}
          onChange={(date) => {
            if (!date && onAgree) onAgree(null); // Pass null when no date is selected
          }}
          slots={{
            textField: (params) => (
              <OutlinedInput
                {...params}
                value={
                  params.inputProps.value &&
                  (onlyMonth
                    ? format(new Date(params.inputProps.value), 'MM/yyyy', { locale: vi }) // Format as MM/yyyy
                    : format(new Date(params.inputProps.value), 'dd/MM/yyyy', { locale: vi })) // Format as dd/MM/yyyy
                } // Format displayed value dynamically
              />
            ),
          }}
          slotProps={{
            toolbar: {
              hidden: true,
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default MyStaticDatePicker;
